import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import Header from "../components/Header";
import { UnitMoodCard } from "../components/UnitMoodCard";
import { ArrowLeft, Activity } from "lucide-react";

const RANGES = [8, 12, 26];

export default function MoodTrendPage() {
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const orgId = params.get("org");
  const nodeId = params.get("node");
  const weeks = Number(params.get("weeks") || 12);
  const [orgs, setOrgs] = useState([]);
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/organizations").then(({ data: d }) => setOrgs(d));
  }, []);

  useEffect(() => {
    if (!nodeId) return;
    setData(null);
    api.get(`/nodes/${nodeId}/mood-trend`, { params: { weeks } }).then(({ data: d }) => setData(d), () => setData({ units: [] }));
  }, [nodeId, weeks]);

  return (
    <div className="min-h-screen bg-white" data-testid="mood-trend-page">
      <Header orgs={orgs} currentOrgId={orgId} currentNodeId={nodeId} onSelectOrg={(id) => navigate(`/employees?org=${id}`)} />
      <main className="max-w-6xl mx-auto px-6 py-10">
        <button onClick={() => navigate(`/employees?org=${orgId}&node=${nodeId}`)} className="font-mono text-xs text-zinc-500 hover:text-zinc-900 flex items-center gap-1 mb-4" data-testid="mood-trend-back">
          <ArrowLeft className="h-3 w-3" /> Terug naar medewerkers
        </button>
        <div className="flex items-end justify-between gap-6 mb-8 border-b border-zinc-900 pb-6 flex-wrap">
          <div>
            <div className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-2 flex items-center gap-2"><Activity className="h-3.5 w-3.5" /> {data?.node?.name || "…"}</div>
            <h1 className="font-grotesk text-4xl sm:text-5xl font-bold tracking-tight">Stemmingsverloop</h1>
            <p className="text-sm text-zinc-600 mt-2 max-w-xl">Per week de stand aan het eind van de week: hoeveel medewerkers zich gestresst, neutraal of ontspannen voelen. De lijn is de gemiddelde score (−1 gestresst, 0 neutraal, +1 ontspannen). Systeem I telt alle onderliggende niveaus mee.</p>
          </div>
          <div className="flex border border-zinc-900" data-testid="mood-trend-range">
            {RANGES.map((w) => (
              <button key={w} onClick={() => setParams({ org: orgId, node: nodeId, weeks: w })} data-testid={`mood-trend-weeks-${w}`}
                className={`px-3 py-1.5 text-sm transition-colors ${w === weeks ? "bg-zinc-900 text-white" : "hover:bg-zinc-100"}`}>{w} weken</button>
            ))}
          </div>
        </div>
        {!data && <p className="font-mono text-sm text-zinc-500">Laden…</p>}
        {data && data.units.length === 0 && <p className="text-sm text-zinc-400" data-testid="mood-trend-empty">Er zijn geen medewerkers waarvan je de stemming mag zien op dit niveau.</p>}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {data?.units.map((u) => <UnitMoodCard key={u.key} unit={u} />)}
        </div>
      </main>
    </div>
  );
}
